const prefix = {
  v1: '/api/auth',
} as const;

export const authPaths = {
  loginByEmail: `${prefix.v1}/login`,
  login: `${prefix.v1}/login`,
  signup: `${prefix.v1}/signup`,
  googleVerify: `${prefix.v1}/google/verify`,
  appleVerify: `${prefix.v1}/apple/verify`,
  checkEmailStatus: `${prefix.v1}/check-email-status`,
  emailSend: `${prefix.v1}/email/send`,
  emailVerify: `${prefix.v1}/email`,
  passwordReset: `${prefix.v1}/password/reset`,
  withdraw: `${prefix.v1}/withdraw`,
  // TRAD-3590 — 서버 세션(리프레시 토큰 키) 폐기. 바디 {refreshTokenKey}, 응답 result.result = "true"|"false"(문자열).
  logout: `${prefix.v1}/logout`,
} as const;
